var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',_vm._b({staticClass:"py-4 px-6 text-sm bg-white border-b-8 border-gray-100 whitespace-no-wrap"},'td',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }